import Vue from "vue";

// Components
import "./components";

// Plugins
// import "./plugins";

// Sync router with store
import { sync } from "vuex-router-sync";

import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "@/router";
import store from "@/store";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
import http from "@/services/http";

import moment from "moment";

import filters from "./filters";

Vue.prototype.$http = http;

// Sync store with router
sync(store, router);

moment.locale(navigator.language);

filters.forEach((f) => {
  Vue.filter(f.name, f.execute);
});

Vue.config.productionTip = false;

Vue.config.errorHandler = function (err) {
  if (
    err &&
    (err.name === "NavigationDuplicated" || err.name === "NavigationRedirected")
  ) {
    return;
  }
  throw err;
};

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
